export default "__VITE_ASSET__CdkZ7iaO__"